// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story"}[chunkId] || chunkId) + "-" + {"3093":"fd7f0455ec1649702d23","3180":"b4439e63277f46397e76","8904":"1070a32283c6c0647292"}[chunkId] + ".css";
};